window.addEventListener('DOMContentLoaded', () => {
    const cards = Array.from(document.querySelectorAll(".product-info-card") || []);
    
    const observerOptions = {
        root: null,
        threshold: 0.5
    };

    const visibilityObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const card = entry.target;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "plp_card_visible",
                    card_name: card.dataset.cardtitle
                });

                observer.unobserve(card);
            }
        });
    }, observerOptions);

    cards.forEach(card => {
        visibilityObserver.observe(card);

        card.addEventListener("pointerenter", () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "plp_card_hover",
                card_name: card.dataset.cardtitle
            });
        });
    });
});